import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase-client';

export const GIPHY_RATINGS = ['g', 'pg', 'pg-13', 'r'];

export function normalizeGiphyRating(value = '', fallback = 'g') {
  const normalized = String(value || '').trim().toLowerCase();
  return GIPHY_RATINGS.includes(normalized) ? normalized : fallback;
}

function imageFromGif(gif = {}) {
  return gif.images?.fixed_height
    || gif.images?.fixed_width
    || gif.images?.downsized
    || gif.images?.original
    || {};
}

function previewFromGif(gif = {}) {
  return gif.images?.fixed_height_small_still
    || gif.images?.fixed_width_small_still
    || gif.images?.preview_gif
    || gif.images?.downsized_still
    || imageFromGif(gif);
}

export function normalizeGiphyGif(gif = {}) {
  const image = imageFromGif(gif);
  const preview = previewFromGif(gif);
  if (!gif?.id || !image?.url) return null;
  return {
    provider: 'giphy',
    providerId: String(gif.id),
    rating: normalizeGiphyRating(gif.rating, 'g'),
    title: String(gif.title || gif.slug || 'GIF').trim() || 'GIF',
    url: image.url,
    previewUrl: preview.url || image.url,
    width: Number(image.width || gif.images?.original?.width || 0) || 0,
    height: Number(image.height || gif.images?.original?.height || 0) || 0,
  };
}

export async function searchGiphy({ query = '', rating = 'g', limit = 24, surface = 'boards' } = {}) {
  const fn = httpsCallable(functions, 'searchGiphyGifs');
  const response = await fn({
    query: String(query || '').trim(),
    rating: normalizeGiphyRating(rating, 'g'),
    limit,
    surface,
  });
  return Array.isArray(response.data?.gifs) ? response.data.gifs : [];
}

export async function listGiphyUsageStats(days = 30) {
  const fn = httpsCallable(functions, 'listGiphyUsageStats');
  const response = await fn({ days });
  return response.data || {};
}

export function buildBoardGiphyHtml(gif = {}) {
  const id = String(gif.providerId || '').trim();
  if (!id) return '';
  const title = escapeHtml(gif.title || 'GIF');
  const url = escapeHtml(gif.url || '');
  const previewUrl = escapeHtml(gif.previewUrl || gif.url || '');
  const rating = escapeHtml(normalizeGiphyRating(gif.rating, 'g'));
  const width = Number(gif.width || 0) || 0;
  const height = Number(gif.height || 0) || 0;
  return `<figure data-giphy-embed="true" data-giphy-id="${escapeHtml(id)}" data-giphy-title="${title}" data-giphy-rating="${rating}"><img data-giphy-image="true" src="${url}" data-preview-src="${previewUrl}" alt="${title}"${width ? ` width="${width}"` : ''}${height ? ` height="${height}"` : ''}><figcaption class="giphy-attribution">Powered by GIPHY</figcaption></figure>`;
}

export function escapeHtml(value = '') {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
